// MULTINOSTALGIA PATCH: added `export` so the mappers registry is
// shared across ESM module boundaries. The upstream file declares this
// as a script-global; our vendoring converts it to a named export.
export let mappers = [];
// the mapper files will add to this array
//# sourceMappingURL=mappers.js.map